module.exports = __webpack_public_path__ + "static/media/hands.fec5155b.jpg";